// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"az_Wnb","question":"az_Xnb","answer":"az_Ynb","accordionItem":"az_Znb"};